// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modale de suggestion d'un nouveau lot technique (bouton "+ Autres"). */
.suggerer-lot-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.suggerer-lot-modal {
  position: relative;
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 2.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.suggerer-lot-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  color: #9ca3af;
  cursor: pointer;
}

.suggerer-lot-close:hover {
  color: #374151;
}

.suggerer-lot-title {
  margin: 0 0 1rem 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: #595959;
}

.suggerer-lot-intro {
  font-size: 1.3rem;
  color: #6b7280;
  margin: 0 0 1.5rem 0;
}

.suggerer-lot-field {
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
}

.suggerer-lot-field label {
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.4rem;
}

.suggerer-lot-required {
  color: #ef4444;
}

.suggerer-lot-field input,
.suggerer-lot-field textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 0.6rem 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 1.3rem;
  color: #374151;
  font-family: inherit;
}

.suggerer-lot-field input:focus,
.suggerer-lot-field textarea:focus {
  outline: none;
  border-color: #f97316;
}

.suggerer-lot-field textarea {
  resize: vertical;
}

/* Champ montant : input + suffixe € (le € n'est PAS dans l'input). */
.suggerer-lot-input-euro {
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding-right: 0.75rem;
}

.suggerer-lot-input-euro:focus-within {
  border-color: #f97316;
}

.suggerer-lot-field .suggerer-lot-input-euro input {
  flex: 1 1;
  border: none;
  border-radius: 6px 0 0 6px;
}

.suggerer-lot-field .suggerer-lot-input-euro input:focus {
  outline: none;
  border: none;
}

.suggerer-lot-euro {
  padding-left: 0.5rem;
  color: #6b7280;
  font-size: 1.3rem;
  font-weight: 600;
}

.suggerer-lot-error {
  color: #ef4444;
  font-size: 1.25rem;
  margin: 0 0 1rem 0;
}

.suggerer-lot-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.suggerer-lot-btn-primary {
  background: #f97316;
  border: 1px solid #f97316;
  color: #fff;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 0.6rem 1.25rem;
  border-radius: 6px;
  cursor: pointer;
}

.suggerer-lot-btn-primary:hover:not(:disabled) {
  background: #ea6a0c;
}

.suggerer-lot-btn-primary:disabled {
  opacity: 0.6;
  cursor: default;
}

.suggerer-lot-btn-secondary {
  background: none;
  border: 1px solid #d1d5db;
  color: #374151;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 0.6rem 1.25rem;
  border-radius: 6px;
  cursor: pointer;
}

.suggerer-lot-btn-secondary:hover:not(:disabled) {
  background: #f3f4f6;
}

.suggerer-lot-success {
  text-align: center;
}

.suggerer-lot-success p {
  font-size: 1.4rem;
  color: #374151;
  margin: 0 0 1.5rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/composants/EstimationBesoins/SuggererLotModal.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB","sourcesContent":["/* Modale de suggestion d'un nouveau lot technique (bouton \"+ Autres\"). */\n.suggerer-lot-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.suggerer-lot-modal {\n  position: relative;\n  background: #fff;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 2.5rem;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.suggerer-lot-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1.6rem;\n  line-height: 1;\n  color: #9ca3af;\n  cursor: pointer;\n}\n\n.suggerer-lot-close:hover {\n  color: #374151;\n}\n\n.suggerer-lot-title {\n  margin: 0 0 1rem 0;\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #595959;\n}\n\n.suggerer-lot-intro {\n  font-size: 1.3rem;\n  color: #6b7280;\n  margin: 0 0 1.5rem 0;\n}\n\n.suggerer-lot-field {\n  margin-bottom: 1.25rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.suggerer-lot-field label {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.4rem;\n}\n\n.suggerer-lot-required {\n  color: #ef4444;\n}\n\n.suggerer-lot-field input,\n.suggerer-lot-field textarea {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0.6rem 0.75rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 1.3rem;\n  color: #374151;\n  font-family: inherit;\n}\n\n.suggerer-lot-field input:focus,\n.suggerer-lot-field textarea:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.suggerer-lot-field textarea {\n  resize: vertical;\n}\n\n/* Champ montant : input + suffixe € (le € n'est PAS dans l'input). */\n.suggerer-lot-input-euro {\n  display: flex;\n  align-items: center;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding-right: 0.75rem;\n}\n\n.suggerer-lot-input-euro:focus-within {\n  border-color: #f97316;\n}\n\n.suggerer-lot-field .suggerer-lot-input-euro input {\n  flex: 1;\n  border: none;\n  border-radius: 6px 0 0 6px;\n}\n\n.suggerer-lot-field .suggerer-lot-input-euro input:focus {\n  outline: none;\n  border: none;\n}\n\n.suggerer-lot-euro {\n  padding-left: 0.5rem;\n  color: #6b7280;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.suggerer-lot-error {\n  color: #ef4444;\n  font-size: 1.25rem;\n  margin: 0 0 1rem 0;\n}\n\n.suggerer-lot-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.suggerer-lot-btn-primary {\n  background: #f97316;\n  border: 1px solid #f97316;\n  color: #fff;\n  font-weight: 600;\n  font-size: 1.3rem;\n  padding: 0.6rem 1.25rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.suggerer-lot-btn-primary:hover:not(:disabled) {\n  background: #ea6a0c;\n}\n\n.suggerer-lot-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.suggerer-lot-btn-secondary {\n  background: none;\n  border: 1px solid #d1d5db;\n  color: #374151;\n  font-weight: 600;\n  font-size: 1.3rem;\n  padding: 0.6rem 1.25rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.suggerer-lot-btn-secondary:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.suggerer-lot-success {\n  text-align: center;\n}\n\n.suggerer-lot-success p {\n  font-size: 1.4rem;\n  color: #374151;\n  margin: 0 0 1.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
